// extracted by css-extract-rspack-plugin
export default {"wordsList":"wordsList-W1FSJX","wordsListRow":"wordsListRow-XWlX9k"};